import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Button from '../common/ButtonComponent';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import AccountsActionCreator from '../../actions/AccountsActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import { sayMessage } from '../../actions/AccessibilityActionCreator';
import MoveMoneyActionCreator from '../../actions/MoveMoneyActionCreator';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import AccountsStore from '../../stores/AccountsStore';
import StringConstant from '../../constants/StringConstants';
import NumberUtils from '../../utils/NumberUtils';
import SvgIcon from '../common/SvgIcon';
import DateUtils from '../../utils/DateUtils';
import { focusOnFirstComponent } from '../common/focusOnFirstComponent';
import MoveMoneyBL from './MoveMoneyBL';
import Panel from './Panel';

class ThankYou extends Component {
  constructor(props) {
    super(props);
    this.goToAccounts = this.goToAccounts.bind(this);
    this.makePayment = this.makePayment.bind(this);
    this.repeatSetup = this.repeatSetup.bind(this);
    this.renderOneOffSuccessMessage =
      this.renderOneOffSuccessMessage.bind(this);
    this.renderStandingOrderSuccessMessage =
      this.renderStandingOrderSuccessMessage.bind(this);
    this.showQuickLinks = this.showQuickLinks.bind(this);
    this.showQuickLinks = this.showQuickLinks.bind(this);
    this.repeatLink = this.repeatLink.bind(this);
    this.onAccountStore = this.onAccountStore.bind(this);
    this.getSideNavData = this.getSideNavData.bind(this);
    this.linkClicked = this.linkClicked.bind(this);
    this.state = {
      repeatData: MoveMoneyStore.getRepeatData(),
      stepHeader: this.props.content.paymentSuccesHeadingSO,
      accountServiceResponse: false,
    };
  }

  componentWillMount() {
    AccountsActionCreator.getAccountsList();
    MoveMoneyStore.setInReviewFlag(false);
    this.setState({
      amount: NumberUtils.appendCurrency(
        '{}',
        Number(this.state.repeatData.amount)
      ),
      name: this.getBenificaryName(
        this.state.repeatData.repeatPaymentOptions.isTransfer
      ),
    });
    if (this.state.repeatData.oneOffPayment) {
      const dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(
        this.state.repeatData.futureDate
      );
      if (dateDifference === 0) {
        this.setState({
          stepHeader: this.state.repeatData.repeatPaymentOptions.isTransfer
            ? this.props.content.trnasferOneOff
            : this.props.content.paymentSuccesHeadingOneOff,
        });
      }
    }
    AccountsStore.addChangeListener(this.onAccountStore);
  }
  componentDidMount() {
    focusOnFirstComponent(this.refs.accessH1ID);
    window.scrollTo(0, 0);
  }
  componentWillUnmount() {
    AccountsStore.removeChangeListener(this.onAccountStore);
  }
  onAccountStore() {
    this.state.accountServiceResponse = true;
  }
  getBenificaryName(isTransfer) {
    let name = '';
    if (isTransfer) {
      const potData = MoveMoneyStore.getSelectedToPot();
      if (!_.isEmpty(potData) && potData.name !== 'Not in Pot') {
        name = potData.name;
      } else {
        name = MoveMoneyStore.getSelectedToAccount().displayName;
      }
    } else {
      if (
        MoveMoneyStore.getSelectedPayee().hasOwnProperty('display_name') &&
        MoveMoneyStore.getSelectedPayee().display_name !== ''
      ) {
        name = MoveMoneyStore.getSelectedPayee().display_name;
      } else {
        name = MoveMoneyStore.getSelectedPayee().to_account.name;
      }
    }

    return name;
  }
  getSideNavData() {
    let sideData = [];
    if (AccountsStore.getManagePaymentsFlag()) {
      if (AccountsStore.isCreditCardUser()) {
        sideData.push({ id: 1, name: 'Manage your scheduled payments' });
      } else {
        sideData.push({
          id: 1,
          name: 'Manage your Direct Debits, standing orders and other scheduled payments',
        });
      }
    }
    if (AccountsStore.getManagePayeesFlag()) {
      sideData.push({ id: 2, name: this.props.content.managePageheaderTitle });
    }
    return sideData;
  }
  goToAccounts() {
    MoveMoneyActionCreator.resetData();
    MoveMoneyPayeeStore.resetStore();
    InternetBankingActions.navigateToWebTask('WEB-HOMEPAGE');
  }
  linkClicked(e) {
    this.props.linkClicked(e);
  }
  makePayment() {
    // Sequence is imp
    MoveMoneyStore.resetStoreForMakePayment();
    this.props.gotToMoveMoneyPageFlag();
    this.props.viewLoader(!this.state.accountServiceResponse);
    MoveMoneyPayeeStore.resetFlags();
  }
  repeatLink() {
    if (
      MoveMoneyStore.isOneOffPayment() &&
      !MoveMoneyStore.getOneOffPayment().isMonthly &&
      !MoveMoneyStore.getResetOneOff()
    ) {
      return (
        <div>
          <Button
            btnName="Set up regular transfer"
            onClick={this.repeatSetup}
            className="c-btn c-btn--secondary"
          />
        </div>
      );
    } else {
      return null;
    }
  }
  repeatSetup() {
    const { handleRefreshForRepeatingPotPaymentSetup } = this.props;
    MoveMoneyStore.resetStoreForResetPayment();

    const paymentDetails = {
      ...MoveMoneyStore.getOneOffPayment(),
      isMonthly: true,
    };
    MoveMoneyStore.setRegularAmount(paymentDetails);
    MoveMoneyActionCreator.spendingTransferMoney(paymentDetails);

    const potAccount = MoveMoneyStore.getPotDetails(paymentDetails.id);
    const isRepeatingPotPayment = potAccount?.pots?.find(
      (item) => item.id === paymentDetails.potId
    );

    /**
     * DP (CX-10232):
     * Unfortunately due to the vauge rendering logic of `repeatLink`,
     * we're not exacly sure on all of the scenarions where we could
     * call the `repeatSetup` method.
     *
     * Additional check included to call `handleRefreshForRepeatingPotPaymentSetup`
     * only for the following flow:
     *  - create new saving pot
     *  - one-off payment
     *  - set up regular payment through `ThankYou` component (this)
     */
    if (isRepeatingPotPayment) {
      handleRefreshForRepeatingPotPaymentSetup();
      return;
    }

    this.props.gotToMoveMoneyPageFlag();
  }
  showQuickLinks() {
    const managePayee = AccountsStore.getManagePayeesFlag();
    const managePayment = AccountsStore.getManagePaymentsFlag();
    const managePaymentText = AccountsStore.isCreditCardUser()
      ? StringConstant.managePaymentQuickLink_CreditCard
      : StringConstant.managePaymentQuickLink;
    return (
      (managePayee || managePayment) && (
        <aside className="move-money--thank-you__quick-links quick-links">
          <div className="quick-links__header">
            <span className="header-icon">
              <svg viewBox="0 0 32 32" width="16px" height="16px" role="img">
                <use xlinkHref="../images/bow/bow-sprite.svg#icon-quickLinks" />
              </svg>
            </span>
            <h4>Quick links</h4>
          </div>
          <ul className="quick-links__content">
            {managePayment && (
              <li>
                <a
                  href="javascript:void(0)"
                  onClick={this.props.ManagePayments}
                >
                  {managePaymentText}
                </a>
              </li>
            )}
            {managePayee && (
              <li>
                <a href="javascript:void(0)" onClick={this.props.managePayee}>
                  {StringConstant.managePayeeQuickLink}
                </a>
              </li>
            )}
          </ul>
        </aside>
      )
    );
  }
  renderOneOffSuccessMessage() {
    let explanation = null;
    let message = null;
    let footerMessage = null;
    const dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(
      this.state.repeatData.futureDate
    );
    const futureDate = MoveMoneyBL.getDateModified(
      this.state.repeatData.futureDate,
      dateDifference
    );

    if (dateDifference === 0) {
      if (this.state.repeatData.repeatPaymentOptions.isTransfer) {
        explanation = this.props.content.transferSuccessSubHeaderOneOff;
        explanation = explanation.replace('{payeename}', this.state.name);
        explanation = explanation.replace('{amount}', this.state.amount);
        message = <p dangerouslySetInnerHTML={{ __html: explanation }} />;
      } else {
        explanation = this.props.content.paymentSuccessSubHeaderOneOff;
        explanation = explanation.replace('{payeename}', this.state.name);
        explanation = explanation.replace('{amount}', this.state.amount);
        message = <p dangerouslySetInnerHTML={{ __html: explanation }} />;
      }
      if (!_.isEmpty(MoveMoneyStore.getMakePaymentResponse())) {
        footerMessage = (
          <p>{MoveMoneyStore.getMakePaymentResponse().message}</p>
        );
      }
    } else {
      let fDPFooter =
        dateDifference === 1
          ? `${this.props.content.paymentSuccesFDPFooterTomorrow} <strong>${StringConstant.Tomorrow}</strong>`
          : `${this.props.content.paymentSuccesFDPFooterDate} <strong>${futureDate}</strong>.`;
      explanation = this.props.content.paymentSuccessSubHeaderFDP;
      explanation = explanation.replace('{payeename}', this.state.name);
      explanation = explanation.replace('{amount}', this.state.amount);
      fDPFooter = <p dangerouslySetInnerHTML={{ __html: fDPFooter }} />;
      message = <p dangerouslySetInnerHTML={{ __html: explanation }} />;
      footerMessage = (
        <div className="c-media__footer">
          <p>
            {this.props.content.scheduledFooter}
            <br />
          </p>
          {fDPFooter}
        </div>
      );
    }
    return (
      <div className="c-media move-money__summary__message">
        <div className="c-media__thumb">
          <SvgIcon id="icon-success" width="24px" height="24px" />
        </div>
        <div className="c-media__body">{message}</div>
        {footerMessage}
      </div>
    );
  }
  renderStandingOrderSuccessMessage() {
    const dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(
      this.state.repeatData.startDate
    );
    const startDate = MoveMoneyBL.getDateModified(
      this.state.repeatData.startDate,
      dateDifference
    );

    let explanation = this.props.content.paymentSuccessSubHeaderSO;
    explanation = explanation.replace('{payeename}', this.state.name);
    explanation = explanation.replace('{amount}', this.state.amount);
    let sOFooter =
      dateDifference === 1
        ? `${this.props.content.paymentSuccesSOFooterTomorrow} <strong>${StringConstant.Tomorrow}</strong>`
        : `${this.props.content.paymentSuccesSOFooterDate} <strong>${startDate}</strong>`;
    sOFooter = <p dangerouslySetInnerHTML={{ __html: sOFooter }} />;
    return (
      <div className="c-media move-money__summary__message">
        <div className="c-media__thumb">
          <SvgIcon id="icon-success" width="24px" height="24px" />
        </div>
        <div className="c-media__body">
          <p dangerouslySetInnerHTML={{ __html: explanation }} />
        </div>
        <div className="c-media__footer">
          <p>{this.props.content.scheduledFooter}</p>
          {sOFooter}
        </div>
      </div>
    );
  }
  render() {
    const iconQuick = 'icon-quickLinks';
    return (
      <div className="container move-money move-money--thank-you">
        <div className="row">
          <div
            className="col-xl1-18 col-lg1-18 col-md1-18 col-sm1-24"
            role="main"
          >
            <div className="move-money__summary">
              {sayMessage(this.state.stepHeader)}
              <div className="c-step-header">
                <h2 className="c-step-header__title type--mull">
                  {this.state.stepHeader}
                </h2>
              </div>
              <div>
                {this.state.repeatData.oneOffPayment
                  ? this.renderOneOffSuccessMessage()
                  : this.renderStandingOrderSuccessMessage()}
              </div>
              {this.repeatLink()}
            </div>
            <div className="move-money--thank-you__options">
              <Button
                btnName={this.props.content.goToAccountsText}
                className="c-btn c-btn--secondary"
                onClick={this.goToAccounts}
              />
              <Button
                btnName={this.props.content.makeAnotherPaymentText}
                className="c-btn c-btn--secondary"
                onClick={this.makePayment}
              />
            </div>
          </div>
          <div className="col-xl1-6 col-lg1-6 col-md1-6">
            {/* this.showQuickLinks()*/}
            {AccountsStore.getManagePaymentsFlag() ||
            AccountsStore.getManagePayeesFlag() ? (
              <Panel
                SideBarlist={this.getSideNavData()}
                linkClicked={this.linkClicked}
                iconClass={iconQuick}
              />
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    );
  }
}

ThankYou.propTypes = {
  content: PropTypes.object,
  payeeName: PropTypes.string,
  icon: PropTypes.array,
  titleName: PropTypes.array,
  tabContent: PropTypes.array,
  handleRefreshForRepeatingPotPaymentSetup: PropTypes.func,
};
ThankYou.defaultProps = {
  payeeName: 'Dave',
  amount: 40.0,
  titleName: ['More than one word Tab', 'Tab2', 'Tab3', 'Tab4', 'Tab5'],
  tabContent: [
    'Default_Props Tab1 Content',
    'Tab2 Content',
    'Tab3 Content',
    'Tab4 Content',
    'Tab5 content',
  ],
};

export default ThankYou;
